<template>
  <div class="page-view container-view" v-loading="saveLoading">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title> 货车通行证预约登记 (当前申请年份{{ canApplyDate }}) </e6-title>
    </section>
    <!-- title end -->
    <section :class="['content-top', { 'no-top-info': stepIndex != 0 }]">
      <div class="step">
        <template>
          <div
            :class="[
              'step-item',
              `stem-item-${i}`,
              { active: stepIndex === i }
            ]"
            v-for="(v, i) in stepList"
            :key="i"
            @click="changeStep(i)"
          >
            <span class="dot">{{ i + 1 }}</span>
            {{ v }}
          </div>
        </template>
      </div>
      <div class="info" v-if="stepIndex == 0">
        <p>
          <!-- 审核 -->
          <el-row
            class="audit-operate"
            v-if="auditOperateShowFun(form.firstStatus)"
          >
            <el-col class="audit-operate-title" :span="2">
              <span>审核不通过</span>
            </el-col>
            <el-col :span="16">
              <el-input
                :disabled="true"
                type="textarea"
                :rows="3"
                placeholder="请输入内容"
                v-model="form.firstRejectionRemark"
              >
              </el-input>
            </el-col>
          </el-row>
        </p>
        <p class="title">
          《广州市冷链配送企业运力保障预约登记表》
          <el-button size="mini" @click="downPdf">下载已填写的文件</el-button>
        </p>
        <p class="tips">
          <i class="e6-icon-tips_line"></i>
          表单填写完成后，请下载并打印文件，加盖企业公章后再次上传电子扫描件
        </p>

        <div>
          <upload-pdf
            :type="formItemEditStatus(form.firstStatus) ? 'update' : 'check'"
            acceptType="all"
            v-model="fileList"
            @uploadCallback="uploadCallback"
            @removeCallback="uploadCallback"
            :titleNo="fileList[0].titleNo"
          ></upload-pdf>
        </div>
      </div>
    </section>
    <!-- content -->
    <section
      ref="content-section"
      :class="['content-section', { 'no-top-info': stepIndex != 0 }]"
    >
      <div class="table-area">
        <el-form :model="form" label-width="160px" ref="form" :key="refresh">
          <div
            class="page page-1"
            ref="page1"
            id="pdfDom"
            :style="{ padding: pdfShow ? '75px 0 0 0 ' : 0 }"
          >
            <el-form-item
              label="企业类型"
              prop="firstTypeList"
              :rules="formRule"
              class="h42"
            >
              <el-checkbox-group
                v-model="form.firstTypeList"
                :disabled="!formItemEditStatus(form.firstStatus)"
              >
                <el-checkbox :label="0">冷链物流企业</el-checkbox>
                <el-checkbox :label="1">商贸流通企业</el-checkbox>
                <el-checkbox :label="2">冷链产品生产企业</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item class="info-title bg-gray">
              <div>1.企业基本情况</div>
            </el-form-item>
            <el-form-item label="1.1企业名称">
              <div>{{ form.companyName }}</div>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="1.2.1注册地址"
                  prop="registeredAddress"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.registeredAddress"
                  ></el-input>
                  <span v-else>{{ form.registeredAddress }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="1.2.2邮编"
                  class="no-border-left"
                  prop="registeredPostCode"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.registeredPostCode"
                  ></el-input>
                  <span v-else>{{ form.registeredPostCode }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="1.3.1通讯地址"
                  prop="mailingAddress"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.mailingAddress"
                  ></el-input>
                  <span v-else>{{ form.mailingAddress }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="1.3.2邮编"
                  class="no-border-left"
                  prop="mailingPostCode"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.mailingPostCode"
                  ></el-input>
                  <span v-else>{{ form.mailingPostCode }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="1.4.1企业网址"
                  prop="companyUrl"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.companyUrl"
                  ></el-input>
                  <span v-else>{{ form.companyUrl }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="1.4.2传真"
                  class="no-border-left"
                  prop="fax"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.fax"
                  ></el-input>
                  <span v-else>{{ form.fax }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  label="1.5.1法人代表"
                  prop="legalPerson"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.legalPerson"
                  ></el-input>
                  <span v-else>{{ form.legalPerson }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="1.5.2联系电话"
                  class="no-border-left"
                  prop="legalPhone"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.legalPhone"
                  ></el-input>
                  <span v-else>{{ form.legalPhone }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="1.5.3身份证号"
                  class="no-border-left"
                  prop="legalCard"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.legalCard"
                  ></el-input>
                  <span v-else>{{ form.legalCard }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  label="1.6.1联系人"
                  prop="contact"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.contact"
                  ></el-input>
                  <span v-else>{{ form.contact }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="1.6.2联系电话"
                  class="no-border-left"
                  prop="contactPhone"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.contactPhone"
                  ></el-input>
                  <span v-else>{{ form.contactPhone }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="1.6.3电子邮箱"
                  class="no-border-left"
                  prop="contactEmail"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.contactEmail"
                  ></el-input>
                  <span v-else>{{ form.contactEmail }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="1.7.1注册资金(万元)"
                  prop="registeredMoney"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.registeredMoney"
                  ></el-input>
                  <span v-else>{{ form.registeredMoney }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="1.7.2其中外资(万元)"
                  class="no-border-left"
                  prop="registeredMoneyOut"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.registeredMoneyOut"
                  ></el-input>
                  <span v-else>{{ form.registeredMoneyOut }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item
                  label="1.8企业性质"
                  prop="companyNature"
                  :rules="formRule"
                >
                  <el-radio-group
                    v-model="form.companyNature"
                    :disabled="!formItemEditStatus(form.firstStatus)"
                    @change="
                      check =>
                        handleChangeClearValid(check, 'companyNatureRemark', 0)
                    "
                  >
                    <el-radio
                      v-for="(v, i) in companyNatureList"
                      :key="i"
                      :label="v.id"
                    >
                      {{ v.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="其他请注明具体性质"
                  class="no-border-left"
                  prop="companyNatureRemark"
                  :rules="form.companyNature === 0 ? formRule : []"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.companyNatureRemark"
                  ></el-input>
                  <span v-else>{{ form.companyNatureRemark }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item
                  label="1.9企业形式"
                  prop="companyForm"
                  :rules="formRule"
                >
                  <el-radio-group
                    :disabled="!formItemEditStatus(form.firstStatus)"
                    v-model="form.companyForm"
                    @change="
                      check =>
                        handleChangeClearValid(check, 'companyFormRemark', 0)
                    "
                  >
                    <el-radio
                      v-for="(v, i) in companyFormList"
                      :key="i"
                      :label="v.id"
                    >
                      {{ v.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="其他请注明具体形式"
                  class="no-border-left"
                  prop="companyFormRemark"
                  :rules="form.companyForm === 0 ? formRule : []"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.companyFormRemark"
                  ></el-input>
                  <span v-else>{{ form.companyFormRemark }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 企业经营情况 -->
            <el-form-item class="info-title bg-gray">
              <div>2.企业经营情况</div>
            </el-form-item>
            <el-row>
              <el-col :span="16">
                <el-form-item
                  label="2.1从事业务"
                  prop="engageBusinessList"
                  :rules="formRule"
                  class="h42"
                >
                  <el-checkbox-group
                    :disabled="!formItemEditStatus(form.firstStatus)"
                    v-model="form.engageBusinessList"
                    @change="
                      check =>
                        handleChangeClearValid(check, 'engageBusinessRemark', 0)
                    "
                  >
                    <el-checkbox
                      v-for="(v, i) in engageBusinessList"
                      :key="i"
                      :label="v.id"
                    >
                      {{ v.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="其他请注明具体业务"
                  class="no-border-left"
                  prop="engageBusinessRemark"
                  :rules="form.engageBusinessList.includes(0) ? formRule : []"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.engageBusinessRemark"
                  ></el-input>
                  <span v-else>{{ form.engageBusinessRemark }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="2.2.1共同配送业务"
                  prop="jointDelivery"
                  :rules="formRule"
                >
                  <el-radio-group
                    :disabled="!formItemEditStatus(form.firstStatus)"
                    v-model="form.jointDelivery"
                    @change="
                      check =>
                        handleChangeClearValid(check, 'jointDeliveryTotal', 1)
                    "
                  >
                    <el-radio
                      v-for="(v, i) in jointDeliveryList"
                      :key="i"
                      :label="v.id"
                    >
                      {{ v.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="若已开展请填写年业务总量(吨)"
                  label-width="225px"
                  prop="jointDeliveryTotal"
                  :rules="form.jointDelivery == 1 ? formRule : []"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.jointDeliveryTotal"
                  ></el-input>
                  <span v-else>{{ form.jointDeliveryTotal }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="merge-line no-border-left">
                  <p>2.3经营状况</p>
                </div>
                <el-form-item class="no-border-left">
                  <div>2.3.1资产总额（万元）</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.3.2经营收入（万元）</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.3.3增值税及所得税（万元）</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.3.4经营时间</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="`${form.assetsTotalTitle}年度`"
                  class="no-border-left"
                  prop="assetsTotal"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.assetsTotal"
                  ></el-input>
                  <span v-else>{{ form.assetsTotal }}</span>
                </el-form-item>
                <el-form-item
                  :label="`${form.assureTotalTitle}年度`"
                  class="no-border-left"
                  prop="assureTotal"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.assureTotal"
                  ></el-input>
                  <span v-else>{{ form.assureTotal }}</span>
                </el-form-item>
                <el-form-item
                  :label="`${form.vatAndIncomeTaxTitle}年度`"
                  class="no-border-left"
                  prop="vatAndIncomeTax"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.vatAndIncomeTax"
                  ></el-input>
                  <span v-else>{{ form.vatAndIncomeTax }}</span>
                </el-form-item>
                <el-form-item
                  label="开始时间（年份）"
                  class="no-border-left"
                  prop="assureDateStart"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.assureDateStart"
                  ></el-input>
                  <span v-else>{{ form.assureDateStart }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="`${form.assetsTotalTwoTitle}年度`"
                  class="no-border-left"
                  prop="assetsTotalTwo"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.assetsTotalTwo"
                  ></el-input>
                  <span v-else>{{ form.assetsTotalTwo }}</span>
                </el-form-item>
                <el-form-item
                  :label="`${form.assureTotalTwoTitle}年度`"
                  class="no-border-left"
                  prop="assureTotalTwo"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.assureTotalTwo"
                  ></el-input>
                  <span v-else>{{ form.assureTotalTwo }}</span>
                </el-form-item>
                <el-form-item
                  :label="`${form.vatAndIncomeTaxTwoTitle}年度`"
                  class="no-border-left"
                  prop="vatAndIncomeTaxTwo"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.vatAndIncomeTaxTwo"
                  ></el-input>
                  <span v-else>{{ form.vatAndIncomeTaxTwo }}</span>
                </el-form-item>
                <el-form-item
                  label="至（年份）"
                  class="no-border-left"
                  prop="assureDateEnd"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.assureDateEnd"
                  ></el-input>
                  <span v-else>{{ form.assureDateEnd }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="merge-line h328">
                  <p>2.4服务能力</p>
                </div>
                <el-form-item class="no-border-left">
                  <div>2.4.1服务网点数（个）</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.4.2客户数量（个）</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.4.3日均配送量（吨）</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.4.4车辆月平均里程（公里）</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.4.5获得行业荣誉、资质或认证</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.4.6参与大型活动项目及服务内容</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.4.7获得政府嘉奖及表彰</div>
                </el-form-item>
                <el-form-item class="no-border-left">
                  <div>2.4.8主要负责人担任社会职务或社团职务情况</div>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item
                  class="info-title no-border-left"
                  prop="serviceNum"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.serviceNum"
                  ></el-input>
                  <span v-else class="fwNormal">{{ form.serviceNum }}</span>
                </el-form-item>
                <el-form-item
                  class="info-title no-border-left"
                  prop="clientNum"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.clientNum"
                  ></el-input>
                  <span v-else class="fwNormal">{{ form.clientNum }}</span>
                </el-form-item>
                <el-form-item
                  class="info-title no-border-left"
                  prop="averageDailyDelivery"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.averageDailyDelivery"
                  ></el-input>
                  <span v-else class="fwNormal">{{
                    form.averageDailyDelivery
                  }}</span>
                </el-form-item>
                <el-form-item
                  class="info-title no-border-left"
                  prop="vehicleMileage"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.vehicleMileage"
                  ></el-input>
                  <span v-else class="fwNormal">{{ form.vehicleMileage }}</span>
                </el-form-item>
                <el-form-item
                  class="info-title no-border-left"
                  prop="industryHonor"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.industryHonor"
                  ></el-input>
                  <span v-else class="fwNormal">{{ form.industryHonor }}</span>
                </el-form-item>
                <el-form-item
                  class="info-title no-border-left"
                  prop="activeProject"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.activeProject"
                  ></el-input>
                  <span v-else class="fwNormal">{{ form.activeProject }}</span>
                </el-form-item>
                <el-form-item
                  class="info-title no-border-left"
                  prop="governmentCite"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.governmentCite"
                  ></el-input>
                  <span v-else class="fwNormal">{{ form.governmentCite }}</span>
                </el-form-item>
                <el-form-item
                  class="info-title no-border-left"
                  prop="personCharge"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.personCharge"
                  ></el-input>
                  <span v-else class="fwNormal">{{ form.personCharge }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="merge-line">
                  <p>2.5设备设施-冷藏车</p>
                </div>
                <el-form-item>
                  <div>2.5.1数量（辆）</div>
                </el-form-item>
                <el-form-item>
                  <div>2.5.2新能源车辆占比（%）</div>
                </el-form-item>
                <el-form-item class="h80">
                  <div>
                    2.5.3符合《道路机动车辆生产企业及产品公告》规定（%）
                  </div>
                </el-form-item>
                <el-form-item>
                  <div>2.5.4冷配车统一标识</div>
                </el-form-item>
                <el-form-item>
                  <div>2.5.5车辆监控系统</div>
                </el-form-item>
                <el-form-item>
                  <div>2.5.6物流信息系统服务商</div>
                </el-form-item>
                <el-form-item>
                  <div>2.5.7上一年度获得冷配证</div>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item class="inline-row no-border-left">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item
                        label="自用（辆）"
                        class="no-border-left"
                        prop="coldVehicleSelfNum"
                        :rules="[
                          {
                            required: true,
                            message: '不能为空',
                            trigger: 'none'
                          }
                        ]"
                      >
                        <el-input
                          v-if="formItemEditStatus(form.firstStatus)"
                          v-model="form.coldVehicleSelfNum"
                        ></el-input>
                        <span v-else>{{ form.coldVehicleSelfNum }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="合作（辆）"
                        prop="coldCooperationVehicleNum"
                        :rules="[
                          {
                            required: true,
                            message: '不能为空',
                            trigger: 'none'
                          }
                        ]"
                      >
                        <el-input
                          v-if="formItemEditStatus(form.firstStatus)"
                          v-model="form.coldCooperationVehicleNum"
                        ></el-input>
                        <span v-else>{{ form.coldCooperationVehicleNum }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item
                  class="info-title no-border-left"
                  prop="energyVehicle"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.energyVehicle"
                  ></el-input>
                  <span v-else class="fwNormal">{{ form.energyVehicle }}</span>
                </el-form-item>
                <el-form-item
                  class="info-title no-border-left h80"
                  prop="conformRoadRegulation"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.conformRoadRegulation"
                  ></el-input>
                  <span v-else class="fwNormal">{{
                    form.conformRoadRegulation
                  }}</span>
                </el-form-item>
                <el-form-item class="inline-row no-border-left">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item
                        class="no-border-left"
                        prop="coldCarMark"
                        :rules="[
                          {
                            required: true,
                            message: '不能为空',
                            trigger: 'none'
                          }
                        ]"
                      >
                        <el-radio-group
                          :disabled="!formItemEditStatus(form.firstStatus)"
                          v-model="form.coldCarMark"
                        >
                          <el-radio :label="0">没有</el-radio>
                          <el-radio :label="1">有（请填写车辆数）</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="若有请填写车辆数"
                        prop="coldCarNum"
                        :rules="form.coldCarMark === 1 ? formRule : []"
                      >
                        <el-input
                          v-if="formItemEditStatus(form.firstStatus)"
                          v-model="form.coldCarNum"
                        ></el-input>
                        <span v-else>{{ form.coldCarNum }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item
                  class="info-title no-border-left"
                  prop="vehicleMonitor"
                  :rules="formRule"
                >
                  <el-radio-group
                    :disabled="!formItemEditStatus(form.firstStatus)"
                    v-model="form.vehicleMonitor"
                  >
                    <el-radio :label="1">100%</el-radio>
                    <el-radio :label="2">70%以上</el-radio>
                    <el-radio :label="0">无</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  class="info-title no-border-left"
                  prop="logisticsInfoSystemServe"
                  :rules="formRule"
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.logisticsInfoSystemServe"
                  ></el-input>
                  <span v-else class="fwNormal">{{
                    form.logisticsInfoSystemServe
                  }}</span>
                </el-form-item>
                <el-form-item class="inline-row no-border-left">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item
                        class="no-border-left"
                        prop="lastYearColdCard"
                        :rules="[
                          {
                            required: true,
                            message: '不能为空',
                            trigger: 'none'
                          }
                        ]"
                      >
                        <el-radio-group
                          :disabled="!formItemEditStatus(form.firstStatus)"
                          v-model="form.lastYearColdCard"
                        >
                          <el-radio :label="0">没有</el-radio>
                          <el-radio :label="1">有（请填写个数）</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="若有请填写个数"
                        prop="lastYearColdCardNum"
                        :rules="form.lastYearColdCard === 1 ? formRule : []"
                      >
                        <el-input
                          v-if="formItemEditStatus(form.firstStatus)"
                          v-model="form.lastYearColdCardNum"
                        ></el-input>
                        <span v-else class="fwNormal">{{
                          form.lastYearColdCardNum
                        }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="merge-line">
                  <p>2.6设备设施-冷库</p>
                </div>
                <el-form-item label="">
                  <div>2.6.1是否有冷库</div>
                </el-form-item>
                <el-form-item label="">
                  <div>2.6.2自建</div>
                </el-form-item>
                <el-form-item label="">
                  <div>2.6.3租赁</div>
                </el-form-item>
                <el-form-item label="">
                  <div>2.6.4仓储信息系统服务商</div>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item
                  class="info-title no-border-left"
                  prop="coldStorageHaveOne"
                  :rules="formRule"
                >
                  <el-radio-group
                    :disabled="!formItemEditStatus(form.firstStatus)"
                    v-model="form.coldStorageHaveOne"
                  >
                    <el-radio :label="0"
                      >没有（没有则不用填写下方冷库相关内容）</el-radio
                    >
                    <el-radio :label="1"
                      >有（有则必须填写下方冷库相关内容）</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item class="inline-row no-border-left">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item
                        label="容量（立方米）"
                        class="no-border-left"
                        prop="coldStorageSelfVolume"
                        :rules="
                          form.coldStorageHaveOne === 1
                            ? [
                                {
                                  required: true,
                                  message: '不能为空',
                                  trigger: 'none'
                                }
                              ]
                            : []
                        "
                      >
                        <el-input
                          v-if="formItemEditStatus(form.firstStatus)"
                          v-model="form.coldStorageSelfVolume"
                        ></el-input>
                        <span v-else>{{ form.coldStorageSelfVolume }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="建设时间（年月日）"
                        prop="coldStorageSelfDate"
                        :rules="
                          form.coldStorageHaveOne === 1
                            ? [
                                {
                                  required: true,
                                  message: '不能为空',
                                  trigger: 'none'
                                }
                              ]
                            : []
                        "
                      >
                        <el-input
                          v-if="formItemEditStatus(form.firstStatus)"
                          v-model="form.coldStorageSelfDate"
                        ></el-input>
                        <span v-else>{{ form.coldStorageSelfDate }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item class="inline-row no-border-left">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item
                        label="容量（立方米）"
                        class="no-border-left"
                        prop="coldStorageLeaseVolume"
                        :rules="
                          form.coldStorageHaveOne === 1
                            ? [
                                {
                                  required: true,
                                  message: '不能为空',
                                  trigger: 'none'
                                }
                              ]
                            : []
                        "
                      >
                        <el-input
                          v-if="formItemEditStatus(form.firstStatus)"
                          v-model="form.coldStorageLeaseVolume"
                        ></el-input>
                        <span v-else>{{ form.coldStorageLeaseVolume }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="协议租赁期（年份）"
                        prop="coldStorageLeaseDate"
                        :rules="
                          form.coldStorageHaveOne === 1
                            ? [
                                {
                                  required: true,
                                  message: '不能为空',
                                  trigger: 'none'
                                }
                              ]
                            : []
                        "
                      >
                        <el-input
                          v-if="formItemEditStatus(form.firstStatus)"
                          v-model="form.coldStorageLeaseDate"
                        ></el-input>
                        <span v-else>{{ form.coldStorageLeaseDate }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item
                  class="info-title no-border-left"
                  prop="storageInfoServe"
                  :rules="
                    form.coldStorageHaveOne === 1
                      ? [
                          {
                            required: true,
                            message: '不能为空',
                            trigger: 'none'
                          }
                        ]
                      : []
                  "
                >
                  <el-input
                    v-if="formItemEditStatus(form.firstStatus)"
                    v-model="form.storageInfoServe"
                  ></el-input>
                  <span v-else class="fwNormal">{{
                    form.storageInfoServe
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="merge-line border-bottom">
                  <p>2.7安全及保障</p>
                </div>
                <el-form-item>
                  <div>2.7.1管理制度</div>
                </el-form-item>
                <el-form-item>
                  <div>2.7.2安全教育</div>
                </el-form-item>
                <el-form-item>
                  <div>2.7.3运营保障</div>
                </el-form-item>
                <el-form-item class="border-bottom">
                  <div>2.7.4应急预案</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item class="info-title fwNormal no-border-left">
                  <div>有健全的财务、车辆、证照、安全等方面的管理制度</div>
                </el-form-item>
                <el-form-item class="info-title fwNormal no-border-left">
                  <div>
                    有相关安全生产方面的学习、培训、检查、考核等方面的记录
                  </div>
                </el-form-item>
                <el-form-item class="info-title fwNormal no-border-left">
                  <div>有针对运营方面的培训和改善记录等</div>
                </el-form-item>
                <el-form-item
                  class="info-title fwNormal no-border-left border-bottom"
                >
                  <div>有完备的应急预案、演练、记录等</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  class="info-title no-border-left"
                  prop="manageSystem"
                  :rules="formRule"
                >
                  <el-radio-group
                    :disabled="!formItemEditStatus(form.firstStatus)"
                    v-model="form.manageSystem"
                  >
                    <el-radio :label="0">是</el-radio>
                    <el-radio :label="1">否</el-radio>
                    <el-radio :label="2">待完善</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  class="info-title no-border-left"
                  prop="safeEducation"
                  :rules="formRule"
                >
                  <el-radio-group
                    :disabled="!formItemEditStatus(form.firstStatus)"
                    v-model="form.safeEducation"
                  >
                    <el-radio :label="0">是</el-radio>
                    <el-radio :label="1">否</el-radio>
                    <el-radio :label="2">待完善</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  class="info-title no-border-left"
                  prop="assureGuarantee"
                  :rules="formRule"
                >
                  <el-radio-group
                    :disabled="!formItemEditStatus(form.firstStatus)"
                    v-model="form.assureGuarantee"
                  >
                    <el-radio :label="0">是</el-radio>
                    <el-radio :label="1">否</el-radio>
                    <el-radio :label="2">待完善</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  class="info-title no-border-left border-bottom"
                  prop="emergencyPlan"
                  :rules="formRule"
                >
                  <el-radio-group
                    :disabled="!formItemEditStatus(form.firstStatus)"
                    v-model="form.emergencyPlan"
                  >
                    <el-radio :label="0">是</el-radio>
                    <el-radio :label="1">否</el-radio>
                    <el-radio :label="2">待完善</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="corp-statement" v-if="pdfShow">
              <p class="title">企业承诺或企业声明（加盖公章）</p>
              <div class="content">
                本企业确认并承诺以上内容均为真实、有效，并知悉如提供虚假材料将接受的相关处罚和承担的法律责任。
              </div>
            </div>
            <!-- <div class="time"></div> -->
            <div class="fill-time" v-if="pdfShow">
              填表时间:{{ fillingTime }}
            </div>
          </div>
          <!-- 第二页数据 -->
          <div class="page page-2" ref="page2">
            <div class="info-wrapper">
              <p class="info-wrapper_title">
                1.企业证件信息上传
                <span class="upload-tips-title"
                  >（只能上传jpg/png文件,且不超过2M）</span
                >
              </p>
              <div class="upload-img">
                <template v-for="(v, index) in pictureSourceList">
                  <el-form-item
                    class="img-item"
                    :key="index"
                    label-width="0"
                    :prop="
                      index === 3 ? '' : `pageTwofileList.${v.pictureType}`
                    "
                    :rules="[
                      { required: true, message: '不能为空', trigger: 'none' }
                    ]"
                  >
                    <div :key="index" class="img-content">
                      <p class="upload-title">{{ v.title }}</p>
                      <div class="imgCss">
                        <upload-img
                          height="150px"
                          width="180px"
                          :type="
                            formItemEditStatus(
                              form.companyBaseInfoMap[10].companyBaseInfoStatus
                            )
                              ? 'update'
                              : 'check'
                          "
                          :cardTitle="v.cardTitle"
                          v-model="v.pictureUrl"
                        ></upload-img>
                      </div>
                      <p v-if="index == 1 || index == 2" class="upload-tips">
                        如没有此证请上传说明文件
                      </p>
                    </div>
                  </el-form-item>
                </template>
              </div>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    form.companyBaseInfoMap[10].companyBaseInfoStatus
                  )
                "
              >
                <el-col class="audit-operate-title" :span="2">
                  <span>审核不通过</span>
                </el-col>
                <el-col :span="10">
                  <el-input
                    :disabled="true"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入驳回原因"
                    v-model="form.companyBaseInfoMap[10].rejectionRemark"
                  >
                  </el-input>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">2.企业简介、征信记录上传</p>
              <div class="info-wrapper-sub">
                <p class="info-wrapper-sub_title">2.1 企业简介</p>
                <el-form-item
                  label-width="30px"
                  :prop="`imageListMap[20][0].url`"
                  :rules="formRule"
                >
                  <div>
                    <upload-pdf
                      :type="
                        formItemEditStatus(
                          form.companyBaseInfoMap[20].companyBaseInfoStatus
                        )
                          ? 'update'
                          : 'check'
                      "
                      acceptType="all"
                      v-model="form.imageListMap[20]"
                      :titleNo="form.imageListMap[20][0].titleNo"
                    ></upload-pdf>
                  </div>
                </el-form-item>
              </div>
              <div class="info-wrapper-sub">
                <p class="info-wrapper-sub_title">2.2 企业征信记录</p>
                <el-form-item
                  label-width="30px"
                  :prop="`imageListMap[21][0].url`"
                  :rules="formRule"
                >
                  <div>
                    <upload-pdf
                      :type="
                        formItemEditStatus(
                          form.companyBaseInfoMap[20].companyBaseInfoStatus
                        )
                          ? 'update'
                          : 'check'
                      "
                      acceptType="all"
                      v-model="form.imageListMap[21]"
                      :titleNo="form.imageListMap[21][0].titleNo"
                    ></upload-pdf>
                  </div>
                </el-form-item>
              </div>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    form.companyBaseInfoMap[20].companyBaseInfoStatus
                  )
                "
              >
                <el-col class="audit-operate-title" :span="2">
                  <span>审核不通过</span>
                </el-col>
                <el-col :span="10">
                  <el-input
                    :disabled="true"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入驳回原因"
                    v-model="form.companyBaseInfoMap[20].rejectionRemark"
                  >
                  </el-input>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">
                3.企业与主要客户签订的服务合同、服务网点及路线清单
              </p>
              <div class="info-wrapper-sub">
                <p class="info-wrapper-sub_title">
                  3.1 与主要客户签订的服务合同（若无，请上传说明文件）
                </p>
                <el-form-item
                  label-width="30px"
                  :prop="`imageListMap[31][0].url`"
                  :rules="formRule"
                >
                  <div>
                    <upload-pdf
                      :type="
                        formItemEditStatus(
                          form.companyBaseInfoMap[30].companyBaseInfoStatus
                        )
                          ? 'update'
                          : 'check'
                      "
                      acceptType="all"
                      v-model="form.imageListMap[31]"
                      :titleNo="form.imageListMap[31][0].titleNo"
                    ></upload-pdf>
                  </div>
                </el-form-item>
              </div>
              <div class="info-wrapper-sub">
                <p class="info-wrapper-sub_title">
                  3.2 服务网点及线路清单

                  <el-button
                    v-if="
                      formItemEditStatus(
                        form.companyBaseInfoMap[30].companyBaseInfoStatus
                      )
                    "
                    type="text"
                    @click="downloadFile('服务网点及线路清单模板.xlsx')"
                  >
                    下载模板</el-button
                  >
                  <span class="download-tips">
                    <i class="e6-icon-abnormal_line"></i>
                    请下载模板，填写完成后再次上传文件</span
                  >
                </p>
                <el-form-item
                  label-width="30px"
                  :prop="`imageListMap[32][0].url`"
                  :rules="formRule"
                >
                  <div>
                    <upload-pdf
                      :type="
                        formItemEditStatus(
                          form.companyBaseInfoMap[30].companyBaseInfoStatus
                        )
                          ? 'update'
                          : 'check'
                      "
                      acceptType=".xls,.xlsx"
                      v-model="form.imageListMap[32]"
                      :titleNo="form.imageListMap[32][0].titleNo"
                    ></upload-pdf>
                  </div>
                </el-form-item>
              </div>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    form.companyBaseInfoMap[30].companyBaseInfoStatus
                  )
                "
              >
                <el-col class="audit-operate-title" :span="2">
                  <span>审核不通过</span>
                </el-col>
                <el-col :span="10">
                  <el-input
                    :disabled="true"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入驳回原因"
                    v-model="form.companyBaseInfoMap[30].rejectionRemark"
                  >
                  </el-input>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">
                4.经注册会计事务所审计的本企业上年度财务审计报告
              </p>
              <el-form-item
                label-width="30px"
                :prop="`imageListMap[40][0].url`"
                :rules="[
                  { required: true, message: '不能为空', trigger: 'none' }
                ]"
              >
                <div>
                  <upload-pdf
                    :type="
                      formItemEditStatus(
                        form.companyBaseInfoMap[40].companyBaseInfoStatus
                      )
                        ? 'update'
                        : 'check'
                    "
                    acceptType="all"
                    v-model="form.imageListMap[40]"
                    :titleNo="form.imageListMap[40][0].titleNo"
                  ></upload-pdf>
                </div>
              </el-form-item>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    form.companyBaseInfoMap[40].companyBaseInfoStatus
                  )
                "
              >
                <el-col class="audit-operate-title" :span="2">
                  <span>审核不通过</span>
                </el-col>
                <el-col :span="10">
                  <el-input
                    :disabled="true"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入驳回原因"
                    v-model="form.companyBaseInfoMap[40].rejectionRemark"
                  >
                  </el-input>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">5.企业上年度纳税证明</p>
              <el-form-item
                label-width="30px"
                :prop="`imageListMap[50][0].url`"
                :rules="[
                  { required: true, message: '不能为空', trigger: 'none' }
                ]"
              >
                <div>
                  <upload-pdf
                    :type="
                      formItemEditStatus(
                        form.companyBaseInfoMap[50].companyBaseInfoStatus
                      )
                        ? 'update'
                        : 'check'
                    "
                    acceptType="all"
                    v-model="form.imageListMap[50]"
                    :titleNo="form.imageListMap[50][0].titleNo"
                  ></upload-pdf>
                </div>
              </el-form-item>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    form.companyBaseInfoMap[50].companyBaseInfoStatus
                  )
                "
              >
                <el-col class="audit-operate-title" :span="2">
                  <span>审核不通过</span>
                </el-col>
                <el-col :span="10">
                  <el-input
                    :disabled="true"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入驳回原因"
                    v-model="form.companyBaseInfoMap[50].rejectionRemark"
                  >
                  </el-input>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">
                6.企业管理制度清单及制度内容，包括车辆管理制度、车辆证照管理制度、安全生产管理制度、应急服务措施、服务操作规程等
                <el-form-item
                  label-width="30px"
                  :prop="`imageListMap[60][0].url`"
                  :rules="formRule"
                >
                  <div>
                    <upload-pdf
                      :type="
                        formItemEditStatus(
                          form.companyBaseInfoMap[60].companyBaseInfoStatus
                        )
                          ? 'update'
                          : 'check'
                      "
                      acceptType="all"
                      v-model="form.imageListMap[60]"
                      :titleNo="form.imageListMap[60][0].titleNo"
                    ></upload-pdf>
                  </div>
                </el-form-item>
                <!-- 审核 -->
                <el-row
                  class="audit-operate"
                  v-if="
                    auditOperateShowFun(
                      form.companyBaseInfoMap[60].companyBaseInfoStatus
                    )
                  "
                >
                  <el-col class="audit-operate-title" :span="2">
                    <span>审核不通过</span>
                  </el-col>
                  <el-col :span="10">
                    <el-input
                      :disabled="true"
                      type="textarea"
                      :rows="2"
                      placeholder="请输入驳回原因"
                      v-model="form.companyBaseInfoMap[60].rejectionRemark"
                    >
                    </el-input>
                  </el-col>
                </el-row>
              </p>
              <div></div>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">
                7.上传《{{
                  canApplyDate
                }}年度冷藏车通行预约登记冷链物流类企业申请表》
                <el-button
                  v-if="
                    formItemEditStatus(
                      form.companyBaseInfoMap[70].companyBaseInfoStatus
                    )
                  "
                  type="text"
                  @click="
                    downloadFile(`冷藏车通行预约登记冷链物流类企业申请表.xlsx`)
                  "
                >
                  下载模板</el-button
                >
              </p>
              <el-form-item
                label-width="30px"
                :prop="`imageListMap[70][0].url`"
                :rules="[
                  { required: true, message: '不能为空', trigger: 'none' }
                ]"
              >
                <div>
                  <upload-pdf
                    :type="
                      formItemEditStatus(
                        form.companyBaseInfoMap[70].companyBaseInfoStatus
                      )
                        ? 'update'
                        : 'check'
                    "
                    v-model="form.imageListMap[70]"
                    acceptType="all"
                    :titleNo="form.imageListMap[70][0].titleNo"
                  ></upload-pdf>
                </div>
              </el-form-item>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    form.companyBaseInfoMap[70].companyBaseInfoStatus
                  )
                "
              >
                <el-col class="audit-operate-title" :span="2">
                  <span>审核不通过</span>
                </el-col>
                <el-col :span="10">
                  <el-input
                    :disabled="true"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入驳回原因"
                    v-model="form.companyBaseInfoMap[70].rejectionRemark"
                  >
                  </el-input>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">
                8.主要获奖证书等荣誉证明（非必填，最多可上传5个附件）
              </p>
              <el-form-item label-width="30px">
                <div class="upload-wrapper">
                  <span
                    class="tips"
                    v-if="
                      formItemEditStatus(
                        form.companyBaseInfoMap[80].companyBaseInfoStatus
                      )
                    "
                    >建议上传PDF文档，也可上传压缩包、excel、word等文档</span
                  >
                  <el-upload
                    :class="[
                      'upload-demo',
                      {
                        'check-file': !formItemEditStatus(
                          form.companyBaseInfoMap[80].companyBaseInfoStatus
                        )
                      }
                    ]"
                    action="/app/file/upload/file"
                    multiple
                    :file-list="uploadFileList"
                    :on-success="handleSuccess"
                    :on-remove="handleRemove"
                  >
                    <el-button size="mini">
                      <i class="e6-icon-upload_fill"></i>点击上传</el-button
                    >
                  </el-upload>
                  <div
                    :class="[
                      'preview',
                      {
                        'check-file-preview': !formItemEditStatus(
                          form.companyBaseInfoMap[80].companyBaseInfoStatus
                        )
                      }
                    ]"
                  >
                    <template v-for="(v, i) in uploadFileList">
                      <div :key="i">
                        <el-button
                          type="text"
                          @click="preView(v.url)"
                          v-if="
                            v.name.substring(
                              v.name.length - 4,
                              v.name.length
                            ) == '.pdf'
                          "
                          >点击预览</el-button
                        >
                      </div>
                    </template>
                  </div>
                </div>
              </el-form-item>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    form.companyBaseInfoMap[80].companyBaseInfoStatus
                  )
                "
              >
                <el-col class="audit-operate-title" :span="2">
                  <span>审核不通过</span>
                </el-col>
                <el-col :span="10">
                  <el-input
                    :disabled="true"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入驳回原因"
                    v-model="form.companyBaseInfoMap[80].rejectionRemark"
                  >
                  </el-input>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">
                9.企业承诺书
                <el-button
                  v-if="
                    formItemEditStatus(
                      form.companyBaseInfoMap[90].companyBaseInfoStatus
                    )
                  "
                  type="text"
                  @click="downloadFile('企业承诺书.docx')"
                >
                  下载模板</el-button
                >

                <span class="download-tips">
                  <i class="e6-icon-abnormal_line"></i>
                  请下载并打印文件，加盖企业公章后再次上传电子扫描件</span
                >
              </p>
              <el-form-item
                label-width="30px"
                :prop="`imageListMap[90][0].url`"
                :rules="[
                  { required: true, message: '不能为空', trigger: 'none' }
                ]"
              >
                <div>
                  <upload-pdf
                    :type="
                      formItemEditStatus(
                        form.companyBaseInfoMap[90].companyBaseInfoStatus
                      )
                        ? 'update'
                        : 'check'
                    "
                    acceptType="all"
                    v-model="form.imageListMap[90]"
                    :titleNo="form.imageListMap[90][0].titleNo"
                  ></upload-pdf>
                </div>
              </el-form-item>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="
                  auditOperateShowFun(
                    form.companyBaseInfoMap[90].companyBaseInfoStatus
                  )
                "
              >
                <el-col class="audit-operate-title" :span="2">
                  <span>审核不通过</span>
                </el-col>
                <el-col :span="10">
                  <el-input
                    :disabled="true"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入驳回原因"
                    v-model="form.companyBaseInfoMap[90].rejectionRemark"
                  >
                  </el-input>
                </el-col>
              </el-row>
            </div>
          </div>
          <!-- 第三页数据 -->
          <div class="page page-3" ref="page3">
            <div class="info-wrapper">
              <p class="info-wrapper_title">1.冷库信息</p>
              <div class="info-wrapper-sub">
                <p class="info-wrapper-sub_title">1.1 是否有冷库</p>
                <el-form-item
                  label-width="30px"
                  prop="coldStorageHave"
                  :rules="formRule"
                >
                  <el-radio-group
                    :disabled="!formItemEditStatus(form.coldStorageStatus)"
                    v-model="form.coldStorageHave"
                    @change="selectColdStorageHave"
                  >
                    <el-radio :label="1">有</el-radio>
                    <el-radio :label="0">没有</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div class="info-wrapper-sub" v-if="form.coldStorageHave == 1">
                <p class="info-wrapper-sub_title">1.2 冷库类型</p>
                <el-form-item
                  label-width="30px"
                  prop="coldStorageTypeList"
                  :rules="formRule"
                >
                  <el-checkbox-group
                    :disabled="!formItemEditStatus(form.coldStorageStatus)"
                    v-model="form.coldStorageTypeList"
                    @change="changeStorageSelect"
                  >
                    <el-checkbox :label="10">自建</el-checkbox>
                    <el-checkbox :label="20">租赁</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>
              <div
                class="info-wrapper-sub"
                :key="storageTableKey"
                v-if="form.coldStorageTypeList.includes(10)"
              >
                <p class="info-wrapper-sub_title">1.3 自建冷库信息</p>
                <div class="pl30">
                  <el-select
                    v-if="formItemEditStatus(form.coldStorageStatus)"
                    class="sel-select"
                    v-model="selStorage"
                    multiple
                    filterable
                    collapse-tags
                    placeholder="请选择(可输入关键字搜索)"
                    @change="handleSelStorage"
                    @clear="handleClearStorage"
                  >
                    <el-option
                      v-for="item in storageAllList"
                      :key="item.storageId"
                      :label="item.storageName"
                      :value="item.storageId"
                    >
                    </el-option>
                  </el-select>
                  <span class="c666" v-else>
                    已选择冷库：{{
                      form.coldStorageSelfList
                        .map(v => v.coldStorageName)
                        .join("、")
                    }}
                  </span>
                  <!---冷库信息表格--->
                  <p v-if="form.coldStorageSelfList.length">
                    已选仓库信息预览：（{{ form.coldStorageSelfList.length }}个)
                  </p>
                  <el-table
                    :key="storageTableKey"
                    v-if="form.coldStorageSelfList.length"
                    :data="form.coldStorageSelfList"
                    border
                    style="width: 100%"
                  >
                    <el-table-column
                      label=""
                      width="50"
                      v-if="formItemEditStatus(form.coldStorageStatus)"
                    >
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          @click="deleteSelStorage(scope.row)"
                        >
                          删除
                        </el-button>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="冷库名称"
                      min-width="120"
                      align="left"
                    >
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>{{ scope.row.coldStorageName }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="冷库类型" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0"
                          :prop="
                            'coldStorageSelfList.' +
                              scope.$index +
                              '.coldStorageType'
                          "
                          :rules="formRule"
                        >
                          <el-select
                            v-if="formItemEditStatus(form.coldStorageStatus)"
                            class="sel-select"
                            v-model="scope.row.coldStorageType"
                            filterable
                            clearable
                            collapse-tags
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in storageTypeList"
                              :key="item.dicId"
                              :label="item.dicName"
                              :value="item.dicId"
                            >
                            </el-option>
                          </el-select>
                          <div v-else>{{ scope.row.coldStorageTypeName }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="120">
                      <template slot="header">
                        <el-popover
                          placement="top-start"
                          width="200"
                          trigger="hover"
                          content="自定义输入后，需要点击选中下拉框中的相同内容才可输入成功"
                        >
                          <span slot="reference"
                            >存储物品（可自定义输入）<i
                              class="el-icon-warning-outline"
                            ></i
                          ></span>
                        </el-popover>
                      </template>
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0"
                          :prop="
                            'coldStorageSelfList.' +
                              scope.$index +
                              '.coldStorageGood'
                          "
                          :rules="formRule"
                        >
                          <el-select
                            v-if="formItemEditStatus(form.coldStorageStatus)"
                            class="sel-select"
                            v-model="scope.row.coldStorageGood"
                            filterable
                            clearable
                            collapse-tags
                            allow-create
                            default-first-option
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in coldStorageGoodList"
                              :key="item.dicId"
                              :label="item.dicName"
                              :value="item.dicId"
                            >
                            </el-option>
                          </el-select>
                          <div v-else>
                            {{ scope.row.coldStorageGoodName }}
                          </div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="联系人" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0"
                          :prop="
                            'coldStorageSelfList.' +
                              scope.$index +
                              '.coldContactMan'
                          "
                          :rules="formRule"
                        >
                          <el-input
                            v-if="formItemEditStatus(form.coldStorageStatus)"
                            type="text"
                            v-model="scope.row.coldContactMan"
                          ></el-input>
                          <div v-else>{{ scope.row.coldContactMan }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="电话" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0"
                          :prop="
                            'coldStorageSelfList.' +
                              scope.$index +
                              '.coldContactPhone'
                          "
                          :rules="formRule"
                        >
                          <el-input
                            v-if="formItemEditStatus(form.coldStorageStatus)"
                            type="text"
                            v-model="scope.row.coldContactPhone"
                          ></el-input>
                          <div v-else>{{ scope.row.coldContactPhone }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div
                class="info-wrapper-sub"
                v-if="form.coldStorageTypeList.includes(20)"
              >
                <p class="info-wrapper-sub_title">1.4 租赁冷库合同</p>
                <el-form-item
                  label-width="30px"
                  :prop="`imageListMap[113][0].url`"
                  :rules="formRule"
                >
                  <div>
                    <upload-pdf
                      :type="
                        formItemEditStatus(form.coldStorageStatus)
                          ? 'update'
                          : 'check'
                      "
                      acceptType="all"
                      v-model="form.imageListMap[113]"
                      :titleNo="form.imageListMap[113][0].titleNo"
                    ></upload-pdf>
                  </div>
                </el-form-item>
              </div>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="auditOperateShowFun(form.coldStorageStatus)"
              >
                <el-col class="audit-operate-title" :span="2">
                  <span>审核不通过</span>
                </el-col>
                <el-col :span="10">
                  <el-input
                    :disabled="true"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入驳回原因"
                    v-model="form.coldStorageRejectionRemark"
                  >
                  </el-input>
                </el-col>
              </el-row>
            </div>
            <div class="info-wrapper">
              <p class="info-wrapper_title">2.冷藏车信息</p>
              <div class="info-wrapper-sub" :key="vehicleTableKey">
                <p class="info-wrapper-sub_title">2.1 冷藏车信息</p>
                <div class="pl30">
                  <el-select
                    v-if="formItemEditStatus(form.coldVehicleStatus)"
                    class="sel-select"
                    v-model="selVehicle"
                    filterable
                    multiple
                    collapse-tags
                    placeholder="请选择(可输入关键字搜索)"
                    @change="handleSelVehicle"
                    @clear="handleClearVehicle"
                  >
                    <el-option
                      v-for="item in vehicleAllList"
                      :key="item.vehicleId"
                      :label="item.vehicleNum"
                      :value="item.vehicleId"
                    >
                    </el-option>
                  </el-select>
                  <span v-else class="c666">
                    已选择车辆：{{
                      form.coldVehicleDetailList
                        .map(v => v.vehicleNum)
                        .join("、")
                    }}
                  </span>
                  <!-- 车辆信息 -->
                  <p v-if="form.coldVehicleDetailList.length">
                    已选车辆信息预览：（{{
                      form.coldVehicleDetailList.length
                    }}个)
                  </p>
                  <el-table
                    :key="vehicleTableKey"
                    v-if="form.coldVehicleDetailList.length"
                    :data="form.coldVehicleDetailList"
                    border
                    style="width: 100%"
                  >
                    <el-table-column
                      label=""
                      width="50"
                      v-if="formItemEditStatus(form.coldVehicleStatus)"
                    >
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          @click="deleteSelVehicle(scope.row)"
                        >
                          删除
                          <!-- <i class="el-icon-close"></i> -->
                        </el-button>
                      </template>
                    </el-table-column>
                    <el-table-column label="车牌号" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>{{ scope.row.vehicleNum }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="上一年度行驶里程" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0"
                          :prop="
                            'coldVehicleDetailList.' +
                              scope.$index +
                              '.runMileage'
                          "
                          :rules="formRule"
                        >
                          <el-input
                            v-if="formItemEditStatus(form.coldVehicleStatus)"
                            type="text"
                            v-model="scope.row.runMileage"
                          ></el-input>
                          <div v-else>{{ scope.row.runMileage }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="报废时间" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0"
                          :prop="
                            'coldVehicleDetailList.' +
                              scope.$index +
                              '.scrapDate'
                          "
                          :rules="formRule"
                        >
                          <el-date-picker
                            class="pd30"
                            v-if="formItemEditStatus(form.coldVehicleStatus)"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            v-model="scope.row.scrapDate"
                            type="date"
                          >
                          </el-date-picker>
                          <div v-else>{{ scope.row.scrapDate }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="joinDate"
                      label="接入省冷链平台时间"
                      min-width="120"
                    >
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <div>
                            {{
                              scope.row.joinDate
                                ? scope.row.joinDate
                                : scope.row.createdTime
                            }}
                          </div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="上年度违章处罚情况" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0"
                          :prop="
                            'coldVehicleDetailList.' +
                              scope.$index +
                              '.lastIllegalPunish'
                          "
                          :rules="formRule"
                        >
                          <el-input
                            v-if="formItemEditStatus(form.coldVehicleStatus)"
                            type="text"
                            v-model="scope.row.lastIllegalPunish"
                          ></el-input>
                          <div v-else>{{ scope.row.lastIllegalPunish }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="曾获城配证时间" min-width="120">
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <el-input
                            v-if="formItemEditStatus(form.coldVehicleStatus)"
                            type="text"
                            v-model="scope.row.lastGetProof"
                          ></el-input>
                          <div v-else>{{ scope.row.lastGetProof }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="上一次获得冷配证类型"
                      min-width="130"
                    >
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <dict-select
                            v-if="formItemEditStatus(form.coldVehicleStatus)"
                            v-model="scope.row.lastColdDeliveryCard"
                            placeholder="请选择车辆类型"
                            :pkey="'cold_delivery_card_type'"
                            @change="
                              val => changeLastColdDeliveryCard(val, scope.row)
                            "
                          ></dict-select>
                          <div v-else>
                            {{ scope.row.lastColdDeliveryCardStr }}
                          </div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="上一次获得冷配证编号"
                      min-width="110"
                    >
                      <template slot-scope="scope">
                        <el-form-item label-width="0">
                          <el-input
                            v-if="formItemEditStatus(form.coldVehicleStatus)"
                            :disabled="!scope.row.lastColdDeliveryCard"
                            type="text"
                            v-model="scope.row.lastColdDeliveryNo"
                          ></el-input>
                          <div v-else>{{ scope.row.lastColdDeliveryNo }}</div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="info-wrapper-sub">
                <p class="info-wrapper-sub_title">
                  2.2
                  请提供机动车登记证书及《机动车行驶证》的主、副页的正、反面，或冷藏车购置合同及发票
                </p>
                <el-form-item
                  label-width="30px"
                  :prop="`imageListMap[222][0].url`"
                  :rules="formRule"
                >
                  <div>
                    <upload-pdf
                      :type="
                        formItemEditStatus(form.coldVehicleStatus)
                          ? 'update'
                          : 'check'
                      "
                      acceptType="all"
                      v-model="form.imageListMap[222]"
                      :titleNo="form.imageListMap[222][0].titleNo"
                    ></upload-pdf>
                  </div>
                </el-form-item>
              </div>
              <!-- 审核 -->
              <el-row
                class="audit-operate"
                v-if="auditOperateShowFun(form.coldVehicleStatus)"
              >
                <el-col class="audit-operate-title" :span="2">
                  <span>审核不通过</span>
                </el-col>
                <el-col :span="10">
                  <el-input
                    :disabled="true"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入驳回原因"
                    v-model="form.coldVehicleRejectionRemark"
                  >
                  </el-input>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
        <div class="fill-time" v-if="stepIndex == 0">
          填表时间:{{ fillingTime }}
        </div>
      </div>
    </section>
    <!-- content end -->
    <section class="btn-group">
      <el-button @click="goBack()">返回</el-button>
      <el-button @click="submit(0)">保存草稿并返回列表页</el-button>
      <el-button @click="changeStep(stepIndex - 1)" v-if="stepIndex != 0"
        >上一步</el-button
      >
      <el-button @click="changeStep(stepIndex + 1)" v-if="stepIndex != 2"
        >下一步</el-button
      >
      <el-button type="primary" @click="submit(10)">提交</el-button>
    </section>
    <!-- 返回顶部 -->
    <div
      class="backTop"
      title="返回顶部"
      v-if="showBackTopBtn"
      @click="gobackTop"
    >
      <i></i>
    </div>
    <!-- 申请须知 -->
    <div class="application-dialog" v-if="showApplicationDialog">
      <div class="application-dialog-content">
        <div class="title">申请须知</div>
        <div class="application-main" ref="applicationDialog">
          <div ref="application-main">
            <p><b>一、范围</b></p>
            <p>
              广州市生活必需品冷链物资（肉类、果蔬、水产品、奶品、冷藏冷冻食品）保供和医药的商贸流通企业及冷链物流配送企业。
            </p>
            <p><b>二、条件及证明材料要求</b></p>
            <p>（1）在广州注册营运且具有合法营业执照。</p>
            <p>
              （2）企业自有广州市籍号牌冷藏车辆不少于5台，提供车辆自有证明等材料，如行驶证等。
            </p>
            <p>
              （3）企业已经成立并具有连续两年以上的专业冷链配送运营经验，提供营业执照复印件或其他证明文件。
            </p>
            <p>
              （4）企业连续两年总资产500万元以上，提供相关证明文件,如审计报告、汇算清缴等。
            </p>
            <p>
              （5）企业连续两年经营收入合计超过1000万元，提供相关证明文件,如审计报告、汇算清缴等。
            </p>
            <p>
              （6）企业无不良征信记录，未被列入失信被执行人名单；未被列入全国企业信用信息公示系统的经营异常名录或严重违法企业名录；未在“信用中国”网站上存在不良信用记录；近一年未受到有关政府部门处罚且未受到相关行业协会的纪律处分。提供证明材料包括但不限于企业自行登录查询所获结果证明等材料。
            </p>
            <p>
              （7）企业所有冷链配送运输车辆符合国家工业和信息化部关于《道路机动车辆生产企业及产品公告》的相关规定并通过年检年审，提供机动车登记证书及车辆行驶证复印件。
            </p>
            <p>
              （8）企业及其冷链配送运输车辆符合广州市地方标准《城市冷链配送》要求。
            </p>
            <p>
              （9）企业须从事广州市内冷链生活必需品物资配送且在日间早晚高峰有通行需求，所需证明材料包括但不限于能证明配送冷链生活必需品物资种类、配送区域及点位的商业合同、广东冷链公共服务管理平台所获企业名下车辆清单、总里程数等数据及其他材料。
            </p>
            <p>以上条件必须全部满足且有相关佐证材料。</p>
            <p><b>三、注意事项</b></p>
            <p>（1）递交材料须提供目录清单及对应页码，按顺序装订成册。</p>
            <p>（2）纸质版文件一式两份加盖骑缝章，同时提供电子版扫描件。</p>
            <p>（3）所有表格必须用电脑填写，并提供电子文档。</p>
          </div>
        </div>
        <div class="confirm-btn">
          <el-button
            type="primary"
            :disabled="confirmBtnDisabled"
            @click="showApplicationDialog = false"
            >我已阅读</el-button
          >
        </div>
      </div>
    </div>
    <!-- 检验信息提示框 -->

    <el-dialog
      class="valid-dialog"
      title="验证未通过信息展示"
      :visible.sync="validInfoDialog"
      width="700px"
    >
      <div class="valid-item" v-if="firstPageValidList.length">
        <p>第一页以下数据未填写：</p>
        <span v-for="(v, i) in firstPageValidList" :key="i">
          {{ i + 1 }}. {{ v.name }}
        </span>
        <br />
      </div>
      <div class="valid-item" v-if="sencodPageValidList.length">
        <p>第二页以下数据未填写：</p>
        <span v-for="(v, i) in sencodPageValidList" :key="i">
          {{ i + 1 }}. {{ v.name }}
        </span>
        <br />
      </div>
      <div class="valid-item" v-if="thirdPageValidList.length">
        <p>第三页以下数据未填写：</p>
        <span v-for="(v, i) in thirdPageValidList" :key="i">
          {{ i + 1 }}. {{ v.name }}
        </span>
        <br />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="validInfoDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import uploadImg from "@/components/uploadImg";
import uploadPdf from "@/components/uploadPdf";
import { cloneDeep } from "lodash";
import { colNameAndPageIndex } from "../js/index";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
// api
import {
  findStorageAll,
  findVehicleAll,
  saveData,
  updateBookingData,
  getCompanyInfo
} from "@/api/businessApplication";
import { FetchGetDictionaryByKey } from "_private/api/public";

const emptyPictureSourceList = [
  // 从业人员照片
  {
    title: "营业执照",
    cardTitle: "点击上传",
    pictureType: "photo10",
    pictureUrl: ""
  },
  {
    title: "道路运输许可证",
    cardTitle: "点击上传",
    pictureType: "photo11",
    pictureUrl: ""
  },
  {
    title: "食品生产许可证",
    cardTitle: "点击上传",
    pictureType: "photo12",
    pictureUrl: ""
  },
  {
    title: "其他(非必填)",
    cardTitle: "点击上传",
    pictureType: "photo13",
    pictureUrl: ""
  }
];
export default {
  // name: "applicationContent",
  components: { uploadImg, uploadPdf },
  props: {
    pageType: {
      type: String,
      default: "add"
    }
  },
  data() {
    return {
      canApplyDate: "",
      saveLoading: false,
      refresh: new Date().getTime(),
      // 步骤条
      stepIndex: 0,
      // 企业性质
      stepList: ["企业运力保障登记表", "企业基础信息", "冷库、冷藏车信息"],
      url: "", // 上传地址
      fileList: [
        {
          type: 0,
          url: "",
          name: "",
          titleNo: "1-1-"
        }
      ],
      // 仓库下拉
      storageAllList: [],
      selStorage: [],
      storageTableKey: new Date().getTime(),
      // 仓库下拉
      vehicleAllList: [],
      selVehicle: [],
      storageTypeList: [], //冷库类型下拉
      coldStorageGoodList: [], // 储存货物下拉
      vehicleTableKey: new Date().getTime(),
      // 表单校验数据
      firstPageValidList: [],
      sencodPageValidList: [],
      thirdPageValidList: [],
      validInfoDialog: false,
      uploadFileList: [], // 附件数据
      // 表单
      form: {
        bookingId: "",
        bookingRejectionRemark: "", // 整体表单驳回原因
        bookingStatus: 0, // 整体表单审核状态
        coldStorageRejectionRemark: "", // 第三页冷库驳回原因
        coldStorageStatus: 30, // 第三页冷库审核状态
        coldVehicleRejectionRemark: "", // 第三页冷藏车驳回原因
        coldVehicleStatus: 30, // 第三页冷藏车审核状态
        // 第二页状态
        companyBaseInfoMap: {
          10: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          20: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          30: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          40: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          50: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          60: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          70: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          80: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          },
          90: {
            companyBaseInfoStatus: 20, // 审核状态
            rejectionRemark: ""
          }
        },
        firstRejectionRemark: "", // 第一页审核驳回原因
        firstStatus: 30, // 第一页审状态,
        firstTypeList: [], // 企业类型
        companyName: "",
        registeredAddress: "", // 注册地址
        registeredPostCode: "", // 注册地址邮编
        mailingAddress: "", // 通讯地址
        mailingPostCode: "", // 通讯地址邮编
        companyUrl: "", // 企业网址
        fax: "", //传真
        legalPerson: "", //法人代表
        legalPhone: "", //联系电话
        legalCard: "", // 身份证号
        contact: "",
        contactPhone: "",
        contactEmail: "",
        registeredMoney: "", // 注册资金
        registeredMoneyOut: "", // 其中外资
        companyNature: "", // 企业性质
        companyNatureRemark: "", //其他企业性质
        companyForm: "", // 企业形式
        companyFormRemark: "", // 其他企业形式
        engageBusinessList: [], // 从事业务
        engageBusinessRemark: "",
        jointDelivery: "", //共同配送业务
        jointDeliveryTotal: "",
        assetsTotalTitle: "", //资产总额第一年标题
        assetsTotal: "", // 资产总额第一年
        assetsTotalTwoTitle: "", //资产总额第二年标题
        assetsTotalTwo: "", // 资产总额第二年
        assureTotalTitle: "", //经营收入第一年标题
        assureTotal: "", // 经营收入第一年
        assureTotalTwoTitle: "", //经营收入第二年标题
        assureTotalTwo: "", // 经营收入第二年
        vatAndIncomeTaxTitle: "", //增值税及所得税第一年标题
        vatAndIncomeTax: "", // 增值税及所得税第一年
        vatAndIncomeTaxTwoTitle: "", //增值税及所得税第二年标题
        vatAndIncomeTaxTwo: "", // 增值税及所得税第二年
        assureDateStart: "", // 经营开始时间
        assureDateEnd: "", // 经营结束时间
        serviceNum: "", //服务网点数（个）
        clientNum: "", //客户数量（个）
        averageDailyDelivery: "", // 日均配送量
        vehicleMileage: "", // 车辆月平均里程
        industryHonor: "", // 获得行业荣誉、资质或认证
        activeProject: "", // 参与大型活动项目及服务内容
        governmentCite: "", // 获得政府嘉奖及表彰
        personCharge: "", // 主要负责人担任社会职务或社团职务情况
        coldVehicleSelfNum: "", // 自用
        coldCooperationVehicleNum: "", // 合作
        energyVehicle: "", //新能源车辆占比
        conformRoadRegulation: "", //符合《道路机动车辆生产
        coldCarMark: "", //冷配车统一标识
        coldCarNum: "", // 冷配车
        vehicleMonitor: "", // 车辆监控系统
        coldStorageHaveOne: "", // 是否有冷库
        logisticsInfoSystemServe: "", // 物流信息系统服务商
        lastYearColdCard: "", // 上一年度获得冷配证
        lastYearColdCardNum: "",
        coldStorageSelfVolume: "", // 自建容量
        coldStorageSelfDate: "", // 自建时间
        coldStorageLeaseVolume: "", // 租赁容量
        coldStorageLeaseDate: "", // 协议租赁时间
        storageInfoServe: "", // 仓储信息系统服务商
        manageSystem: "", // 有健全的财务、车辆、证照、安全等方面的管理制度
        safeEducation: "", //  有相关安全生产方面
        assureGuarantee: "", // 运营方面
        emergencyPlan: "", // 应急预案
        // 第二页
        pageTwofileList: {
          photo10: "",
          photo11: "",
          photo12: "",
          photo13: ""
        },
        // 0:冷链配送企业运力保障预约登记表、10:营业执照、11:道路运输许可证、12:食品生产许可证、13:其他;
        // 20:企业简介、21:企业征信记录;
        // 31:与主要客户签订的服务合同、32:服务网点及线路清单;
        // 40:经注册会计事务所审计的本企业上年度财务审计报告;\n50:企业上年度纳税证明;
        // 60:企业管理制度清单及制度内容,包括...;7
        //70:保障应急预案、包括应急演练....;
        //80:主要获奖证书等荣誉证明;
        //113:租赁冷库合同;
        //222:冷藏车租赁协议，冷藏车购置合同和发票及《机动车行驶证》的主、副页的正、反面和绿色环保标志

        imageListMap: {
          0: [
            {
              type: 0,
              url: "",
              name: "",
              titleNo: "1-1-"
            }
          ],
          10: [
            {
              type: 10,
              url: "",
              name: "营业执照",
              titleNo: "2-1-"
            }
          ],
          11: [
            {
              type: 11,
              url: "",
              name: "道路运输许可证",
              titleNo: "2-2-"
            }
          ],
          12: [
            {
              type: 12,
              url: "",
              name: "食品生产许可证",
              titleNo: "2-3-"
            }
          ],
          13: [
            {
              type: 13,
              url: "",
              name: "其他",
              titleNo: "2-4-"
            }
          ],
          20: [
            {
              type: 20,
              url: "",
              name: "",
              titleNo: "2-5-"
            }
          ],
          21: [
            {
              type: 21,
              url: "",
              name: "",
              titleNo: "2-6-"
            }
          ],
          31: [
            {
              type: 31,
              url: "",
              name: "",
              titleNo: "2-7-"
            }
          ],
          32: [
            {
              type: 32,
              url: "",
              name: "",
              titleNo: "2-8-"
            }
          ],
          40: [
            {
              type: 40,
              url: "",
              name: "",
              titleNo: "2-9-"
            }
          ],
          50: [
            {
              type: 50,
              url: "",
              name: "",
              titleNo: "2-10-"
            }
          ],
          60: [
            {
              type: 60,
              url: "",
              name: "",
              titleNo: "2-11-"
            }
          ],
          70: [
            {
              type: 70,
              url: "",
              name: "",
              titleNo: "2-12-"
            }
          ],
          80: [
            {
              type: 80,
              url: "",
              name: "",
              titleNo: "2-13-"
            }
          ],
          90: [
            {
              type: 90,
              url: "",
              name: "",
              titleNo: "2-14-"
            }
          ],
          113: [
            {
              type: 113,
              url: "",
              name: "",
              titleNo: "3-1-"
            }
          ],
          222: [
            {
              type: 222,
              url: "",
              name: "",
              titleNo: "3-2-"
            }
          ]
        },
        // 第三页
        coldStorageHave: 1,
        coldStorageTypeList: [], // 冷库类型
        coldStorageSelfList: [],
        coldVehicleDetailList: [],
        lastColdDeliveryCard: "",
        lastColdDeliveryNo: "" // 冷配证编号
      },
      fileSrc: "",
      formRule: [
        {
          required: true,
          message: "不能为空",
          trigger: "none"
        }
      ],
      fillingTime: moment().format("YYYY年MM月DD日"),
      // 企业性质
      companyNatureList: [
        {
          id: 1,
          label: "国有企业"
        },
        {
          id: 2,
          label: "集体所有制企业"
        },
        {
          id: 3,
          label: "外商独资"
        },
        {
          id: 4,
          label: "联营企业"
        },
        {
          id: 5,
          label: "三资企业"
        },
        {
          id: 6,
          label: "私营企业"
        },
        {
          id: 0,
          label: "其他(注明具体性质)"
        }
      ],
      // 企业形式
      companyFormList: [
        {
          id: 1,
          label: "有限责任制公司"
        },
        {
          id: 2,
          label: "股份公司"
        },
        {
          id: 3,
          label: "有限公司"
        },
        {
          id: 0,
          label: "其他(注明具体形式)"
        }
      ],
      // 从事业务
      engageBusinessList: [
        {
          id: 1,
          label: "供应链管理"
        },
        {
          id: 2,
          label: "电子商务物流"
        },
        {
          id: 3,
          label: "民生保障服务"
        },
        {
          id: 4,
          label: "应急供应服务"
        },
        {
          id: 5,
          label: "特殊定温产品"
        },
        {
          id: 0,
          label: "其他(注明具体业务)"
        }
      ],
      jointDeliveryList: [
        {
          id: 0,
          label: "未开展"
        },
        {
          id: 1,
          label: "已开展（请填写年业务总量(吨)）"
        }
      ],
      //-----------------第二页数据-----------------------------
      pictureSourceList: JSON.parse(JSON.stringify(emptyPictureSourceList)),
      //---------申请须知----------
      showApplicationDialog: false,
      confirmBtnDisabled: false,
      // -----------返回顶部----------
      showBackTopBtn: false,
      // 打印pdf
      htmlTitle: "广州市冷链配送企业运力保障预约登记表",
      pdfShow: false,
      curSel: [], // 当前选中车辆
      deleteArr: [] // 当前删除车辆
    };
  },
  created() {
    this.canApplyDate = this.$route.query.canApplyDate;
    // 初始化年份标题
    this.initYearTitles();
  },
  mounted() {
    this.handleBackTop();
    if (this.pageType == "add") {
      this.getStorageAll();
      this.getVehicleAll();
      this.getColdTypeAll();
      this.getColdStorageGoodList();
      // 判断申请须知是否显示
      this.showApplicationDialog = true;
      this.$nextTick(() => {
        let scrollDom = this.$refs.applicationDialog;
        let totalHeight = this.$refs["application-main"].clientHeight;
        let outHeight = this.$refs["applicationDialog"].clientHeight;
        scrollDom.addEventListener("scroll", () => {
          let scrollHeight = scrollDom.scrollTop;
          if (outHeight + scrollHeight >= totalHeight) {
            this.confirmBtnDisabled = false;
          }
        });
      });
    }
    // 监听返回顶部按钮
    // 获取企业名称
    this.getCorpName();
  },
  watch: {
    // 监听路由变化，更新年份标题
    $route(to, from) {
      if (to.query.canApplyDate !== from.query.canApplyDate) {
        this.canApplyDate = to.query.canApplyDate;
        this.initYearTitles();
      }
    }
  },
  methods: {
    //  清空指定的校验
    handleChangeClearValid(val, prop, value2) {
      if (prop == "engageBusinessRemark") {
        if (!val.includes(value2)) {
          this.$refs.form.clearValidate(prop);
        }
      } else {
        if (val !== value2) {
          this.$refs.form.clearValidate(prop);
        }
      }
    },
    // 根据企业id获取企业名称
    async getCorpName() {
      try {
        let res = await getCompanyInfo();
        if (res.code) {
          this.form.companyName = res.result;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 查询仓库下拉
    async getStorageAll() {
      try {
        let { code, result } = await findStorageAll();
        if (code && result) {
          this.storageAllList = result;
          return result;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 查询车辆下拉
    async getVehicleAll() {
      try {
        let { code, result } = await findVehicleAll();
        if (code && result) {
          this.vehicleAllList = result;
          return result;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 查询冷库类型下拉
    async getColdTypeAll() {
      try {
        let { code, result } = await FetchGetDictionaryByKey({
          dicTypeKey: "cold_storage_type"
        });
        if (code && result) {
          this.storageTypeList = result;
          return result;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 查询储存货物下拉
    async getColdStorageGoodList() {
      try {
        let { code, result } = await FetchGetDictionaryByKey({
          dicTypeKey: "store_item"
        });
        if (code && result) {
          this.coldStorageGoodList = result;
          return result;
        }
      } catch (err) {
        console.log(err);
      }
    },
    changeLastColdDeliveryCard(val, row) {
      if (val == "") {
        row.lastColdDeliveryNo = "";
      }
    },
    // 上传图片失败handleSuccess
    handleSuccess(res) {
      if (res.code) {
        if (this.uploadFileList.length == 5) {
          this.$message.warning("最多上传5个文件");
          let temp = {
            url: res.result.fileNameActive,
            name: res.result.fileName,
            titleNo: "2-13-"
          };
          this.uploadFileList.push(temp);
          this.handleRemove(temp);
        } else {
          this.uploadFileList.push({
            url: res.result.fileNameActive,
            name: res.result.fileName,
            titleNo: `2-13-${this.uploadFileList.length + 1}-`
          });
        }
      }
    },
    // 删除图片
    handleRemove(file) {
      let index = this.uploadFileList.findIndex(v => v.url == file.url);
      if (index >= 0) {
        this.uploadFileList.splice(index, 1);
        this.uploadFileList.forEach((v, i) => {
          v.titleNo = `2-13-${i + 1}-`;
        });
      }
    },
    // PDF预览
    preView(val) {
      window.open(val);
    },
    // 监听返回顶部按钮
    handleBackTop() {
      let scrollDom = this.$refs["content-section"];
      scrollDom.addEventListener("scroll", () => {
        let scrollHeight = scrollDom.scrollTop;
        if (scrollHeight > 10) {
          this.showBackTopBtn = true;
        } else {
          this.showBackTopBtn = false;
        }
      });
    },
    // 返回顶部
    gobackTop() {
      let scrollDom = this.$refs["content-section"];
      scrollDom.scrollTop = 0;
    },
    // 下载模板
    downloadFile(val) {
      let base =
        process.env.NODE_ENV == "production" ? window.location.origin : "";
      let templateUrl = `/static/${val}`;
      let downloadIframe = document.createElement("iframe");
      downloadIframe.setAttribute("src", `${base}${templateUrl}` || "");
      downloadIframe.setAttribute("style", "display: none");
      document.body.appendChild(downloadIframe);
    },
    // 审核相关是否展示判断
    auditOperateShowFun(val) {
      // 已驳回状态，修改编辑页，驳回的小类进行展示，通过的不展示
      if (this.pageType == "edit") {
        if (val == 20) {
          return true;
        } else {
          return false;
        }
      }
      // 草稿编辑不展示驳回相关
      if (this.pageType == "draftEdit" || this.pageType == "add") {
        return false;
      }
    },
    // 页面表单元素是否可编辑
    formItemEditStatus(val) {
      if (this.pageType == "draftEdit" || this.pageType == "add") {
        return true;
      }
      if (this.pageType == "edit") {
        // 驳回后可编辑
        if (val == 20) {
          return true;
        } else {
          return false;
        }
      }
    },
    //  处理选择看冷库
    handleSelStorage(val) {
      // 当前选中
      let curSel = val.filter(v => {
        return this.form.coldStorageSelfList.every(i => i.coldStorageId != v);
      });
      // 当前取消
      let deleteArr = this.form.coldStorageSelfList.filter(v => {
        return val.every(i => i != v.coldStorageId);
      });
      // 选中
      if (curSel.length) {
        let temp = this.storageAllList.filter(v => {
          return curSel.find(i => i == v.storageId);
        });
        temp.forEach(v => {
          let obj = {
            coldContactMan: v.contactMan,
            coldContactPhone: v.contactPhone,
            coldStorageGood: v.storageGood == 0 ? "" : v.storageGood,
            coldStorageName: v.storageName,
            coldStorageType: v.coldStorageType,
            coldStorageId: v.storageId
          };
          this.form.coldStorageSelfList.push(obj);
        });
      }
      // 取消
      if (deleteArr.length) {
        let index = this.form.coldStorageSelfList.findIndex(
          v => v.coldStorageId == deleteArr[0].coldStorageId
        );
        this.form.coldStorageSelfList.splice(index, 1);
      }
      // this.storageTableKey = new Date().getTime();
    },
    // 清空仓库
    handleClearStorage() {
      this.form.coldStorageSelfList = [];
    },
    // 处理选择车辆
    handleSelVehicle(val) {
      // 当前选中
      let curSel = val.filter(v => {
        return this.form.coldVehicleDetailList.every(i => i.vehicleId != v);
      });
      // 当前取消
      let deleteArr = this.form.coldVehicleDetailList.filter(v => {
        return val.every(i => i != v.vehicleId);
      });
      if (curSel.length) {
        let temp = this.vehicleAllList.filter(v => {
          return curSel.find(i => i == v.vehicleId);
        });
        temp.forEach(v => {
          let obj = {
            createdTime: v.createdTime,
            vehicleNum: v.vehicleNum,
            joinDate: v.joinDate || v.createdTime,
            lastGetProof: v.lastGetProof,
            lastIllegalPunish: v.lastIllegalPunish,
            runMileage: v.runMileage,
            scrapDate: v.scrapDate,
            vehicleId: v.vehicleId,
            lastColdDeliveryCard: "",
            lastColdDeliveryNo: ""
          };
          this.form.coldVehicleDetailList.push(obj);
        });
      }
      // 取消
      if (deleteArr.length) {
        let index = this.form.coldVehicleDetailList.findIndex(
          v => v.vehicleId == deleteArr[0].vehicleId
        );
        this.form.coldVehicleDetailList.splice(index, 1);
      }
      // this.vehicleTableKey = new Date().getTime();
    },
    // 删除车辆选择
    deleteSelVehicle(row) {
      this.selVehicle = this.selVehicle.filter(v => v != row.vehicleId);
      this.form.coldVehicleDetailList = this.form.coldVehicleDetailList.filter(
        v => v.vehicleId != row.vehicleId
      );
    },

    // 清空仓库
    handleClearVehicle() {
      this.form.coldVehicleDetailList = [];
    },
    // 选择是否有冷库
    selectColdStorageHave() {
      this.form.coldStorageTypeList = [];
      this.changeStorageSelect([]);
    },
    // 选择冷库类型
    changeStorageSelect(val) {
      if (!val.includes(10)) {
        this.form.coldStorageSelfList = [];
        this.selStorage = [];
      }
      if (!val.includes(20)) {
        this.form.imageListMap[113] = [
          {
            type: 113,
            url: "",
            name: "",
            titleNo: "3-1-"
          }
        ];
      }
    },
    // 删除车辆选择
    deleteSelStorage(row) {
      this.selStorage = this.selStorage.filter(v => v != row.coldStorageId);
      this.form.coldStorageSelfList = this.form.coldStorageSelfList.filter(
        v => v.coldStorageId != row.coldStorageId
      );
    },

    // 初始化年份标题
    initYearTitles() {
      // 使用 canApplyDate 计算各个年份标题
      if (this.canApplyDate) {
        this.form.assetsTotalTitle = moment(this.canApplyDate)
          .subtract(2, "year")
          .format("YYYY");
        this.form.assetsTotalTwoTitle = moment(this.canApplyDate)
          .subtract(1, "year")
          .format("YYYY");
        this.form.assureTotalTitle = moment(this.canApplyDate)
          .subtract(2, "year")
          .format("YYYY");
        this.form.assureTotalTwoTitle = moment(this.canApplyDate)
          .subtract(1, "year")
          .format("YYYY");
        this.form.vatAndIncomeTaxTitle = moment(this.canApplyDate)
          .subtract(2, "year")
          .format("YYYY");
        this.form.vatAndIncomeTaxTwoTitle = moment(this.canApplyDate)
          .subtract(1, "year")
          .format("YYYY");
      }
    },
    // 编辑页面填充数据
    init(data) {
      this.saveLoading = true;
      let list = [
        this.getStorageAll(),
        this.getVehicleAll(),
        this.getColdTypeAll(),
        this.getColdStorageGoodList()
      ];
      Promise.all(list)
        .then(() => {
          this.canApplyDate = data.bookingDateStr;
          // 初始化年份标题
          Object.assign(this.form, data);
          this.pictureSourceList[0].pictureUrl = this.form.imageListMap[10][0].url;
          this.pictureSourceList[1].pictureUrl = this.form.imageListMap[11][0].url;
          this.pictureSourceList[2].pictureUrl = this.form.imageListMap[12][0].url;
          this.pictureSourceList[3].pictureUrl = this.form.imageListMap[13][0].url;
          this.fileList = [];
          this.fileList.push(this.form.imageListMap[0][0]);
          this.uploadFileList = [];
          if (this.form.imageListMap[80]) {
            this.form.imageListMap[80].forEach(v => {
              this.uploadFileList.push({
                url: v.url,
                name: v.name,
                titleNo: `${v.titleNo}`
              });
            });
          }
          // 冷库与车辆选择
          this.form.coldStorageSelfList.forEach(v => {
            v.coldStorageType = Number(v.coldStorageType);
            v.coldStorageGood = Number(v.coldStorageGood);
            if (v.coldStorageGood == 0) {
              v.coldStorageGood = v.coldStorageGoodText;
            }
          });
          this.selStorage = this.form.coldStorageSelfList.map(
            v => v.coldStorageId
          );
          this.form.coldVehicleDetailList.forEach(v => {
            if (v.lastColdDeliveryCard == 0) {
              v.lastColdDeliveryCard = "";
            }
          });
          this.selVehicle = this.form.coldVehicleDetailList.map(
            v => v.vehicleId
          );
          this.refresh = new Date().getTime();
          this.saveLoading = false;
          this.$nextTick(() => {
            this.caclFormHeight();
          });
        })
        .catch(error => {
          this.saveLoading = false;
          console.log(error);
        });
    },
    //
    uploadCallback() {
      this.caclFormHeight();
    },
    // 动态计算文件高度
    caclFormHeight() {
      setTimeout(() => {
        // 动态计算文件高度
        let firstTopDom = document.getElementsByClassName("content-top");
        let firstDom = document.getElementsByClassName("content-section");
        let height = firstTopDom[0].clientHeight;
        firstDom[0].style.height = `calc(100% - 54px - 10px - ${height}px - 45px)`;
      }, 1500);
    },
    // 切换步骤条
    changeStep(i) {
      this.stepIndex = i;
      if (i == 0) {
        this.$refs.page1.style.position = "relative";
        this.$refs.page1.style.left = "0%";
        this.$refs.page2.style.position = "absolute";
        this.$refs.page2.style.left = "100%";
        this.$refs.page3.style.position = "absolute";
        this.$refs.page3.style.left = "200%";
      }
      if (i == 1) {
        this.$refs.page1.style.position = "absolute";
        this.$refs.page1.style.left = "-100%";
        this.$refs.page2.style.position = "relative";
        this.$refs.page2.style.left = "0";
        this.$refs.page3.style.position = "absolute";
        this.$refs.page3.style.left = "100%";
      }
      if (i === 2) {
        this.$refs.page1.style.position = "absolute";
        this.$refs.page1.style.left = "-200%";
        this.$refs.page2.style.position = "absolute";
        this.$refs.page2.style.left = "-100%";
        this.$refs.page3.style.position = "relative";
        this.$refs.page3.style.left = "0%";
      }
    },
    // 提交表单
    submit(type) {
      if (type == 10) {
        // 第2页文件数据
        this.pictureSourceList.forEach(v => {
          this.form.pageTwofileList[v.pictureType] = v.pictureUrl;
        });
        this.form.imageListMap[80] = [];
        this.uploadFileList.forEach(v => {
          this.form.imageListMap[80].push({
            type: 80,
            url: v.url,
            name: v.name,
            titleNo: `${v.titleNo}`
          });
        });

        this.$refs.form.validate((valid, obj) => {
          if (valid) {
            this.form.imageListMap[10][0].url = this.form.pageTwofileList.photo10;
            if (this.form.pageTwofileList.photo10) {
              this.form.imageListMap[10][0].name = `营业执照.${
                this.form.pageTwofileList.photo10.split(".")[
                  this.form.pageTwofileList.photo10.split(".").length - 1
                ]
              }`;
            }
            this.form.imageListMap[11][0].url = this.form.pageTwofileList.photo11;
            if (this.form.pageTwofileList.photo11) {
              this.form.imageListMap[11][0].name = `道路运输许可证.${
                this.form.pageTwofileList.photo11.split(".")[
                  this.form.pageTwofileList.photo11.split(".").length - 1
                ]
              }`;
            }
            this.form.imageListMap[12][0].url = this.form.pageTwofileList.photo12;
            if (this.form.pageTwofileList.photo12) {
              this.form.imageListMap[12][0].name = `食品生产许可证.${
                this.form.pageTwofileList.photo12.split(".")[
                  this.form.pageTwofileList.photo12.split(".").length - 1
                ]
              }`;
            }
            this.form.imageListMap[13][0].url = this.form.pageTwofileList.photo13;
            if (this.form.pageTwofileList.photo13) {
              this.form.imageListMap[13][0].name = `其他.${
                this.form.pageTwofileList.photo13.split(".")[
                  this.form.pageTwofileList.photo13.split(".").length - 1
                ]
              }`;
            }
            // Reflect.deleteProperty(this.form, "pageTwofileList");
            if (this.fileList[0].url == "") {
              this.$message.warning(
                "请上传第一页《广州市冷链配送企业运力保障预约登记表》"
              );
            } else {
              this.savePageData(type);
            }
          } else {
            this.firstPageValidList = [];
            this.sencodPageValidList = [];
            this.thirdPageValidList = [];
            let colValidArr = [];
            for (let v in obj) {
              if (colNameAndPageIndex[v]) {
                colValidArr.push(colNameAndPageIndex[v]);
              }
              if (v.includes("coldVehicleDetailList")) {
                let isexist = colValidArr.findIndex(
                  n => n.name == "冷藏车信息"
                );
                if (isexist < 0) {
                  colValidArr.push({
                    name: "冷藏车信息",
                    pageIndex: 3
                  });
                }
              }
              if (v.includes("coldStorageSelfList")) {
                let isexist = colValidArr.findIndex(n => n.name == "冷库信息");
                if (isexist < 0) {
                  colValidArr.push({
                    name: "冷库信息",
                    pageIndex: 3
                  });
                }
              }
            }
            colValidArr.forEach(v => {
              if (v.pageIndex == 1) {
                this.firstPageValidList.push(v);
              }
              if (v.pageIndex == 2) {
                this.sencodPageValidList.push(v);
              }
              if (v.pageIndex == 3) {
                this.thirdPageValidList.push(v);
              }
            });
            this.validInfoDialog = true;
          }
        });
      } else {
        // 第2页文件数据
        this.pictureSourceList.forEach(v => {
          this.form.pageTwofileList[v.pictureType] = v.pictureUrl;
        });
        this.form.imageListMap[80] = [];
        this.uploadFileList.forEach(v => {
          this.form.imageListMap[80].push({
            type: 80,
            url: v.url,
            name: v.name,
            titleNo: `${v.titleNo}`
          });
        });
        this.form.imageListMap[10][0].url = this.form.pageTwofileList.photo10;
        if (this.form.pageTwofileList.photo10) {
          this.form.imageListMap[10][0].name = `营业执照.${
            this.form.pageTwofileList.photo10.split(".")[
              this.form.pageTwofileList.photo10.split(".").length - 1
            ]
          }`;
        }
        this.form.imageListMap[11][0].url = this.form.pageTwofileList.photo11;
        if (this.form.pageTwofileList.photo11) {
          this.form.imageListMap[11][0].name = `道路运输许可证.${
            this.form.pageTwofileList.photo11.split(".")[
              this.form.pageTwofileList.photo11.split(".").length - 1
            ]
          }`;
        }
        this.form.imageListMap[12][0].url = this.form.pageTwofileList.photo12;
        if (this.form.pageTwofileList.photo12) {
          this.form.imageListMap[12][0].name = `食品生产许可证.${
            this.form.pageTwofileList.photo12.split(".")[
              this.form.pageTwofileList.photo12.split(".").length - 1
            ]
          }`;
        }
        this.form.imageListMap[13][0].url = this.form.pageTwofileList.photo13;
        if (this.form.pageTwofileList.photo13) {
          this.form.imageListMap[13][0].name = `其他.${
            this.form.pageTwofileList.photo13.split(".")[
              this.form.pageTwofileList.photo13.split(".").length - 1
            ]
          }`;
        }

        this.savePageData(type);
      }
    },
    // 保存数据
    async savePageData(type) {
      try {
        this.saveLoading = true;
        let params = cloneDeep(this.form);
        params.bookingStatus = type;
        params.imageListMap[0] = [];
        params.imageListMap[0].push(this.fileList[0]);
        params.coldStorageSelfList.forEach(v => {
          let temp = this.coldStorageGoodList.filter(
            n => n.dicId == v.coldStorageGood
          );
          if (temp.length == 0) {
            v.coldStorageGoodText = v.coldStorageGood;
            v.coldStorageGood = "";
          } else {
            v.coldStorageGoodText = "";
          }
        });
        params.bookingDateStr = this.canApplyDate;
        params.coldVehicleDetailList.forEach(v => {
          if (!v.lastColdDeliveryCard) {
            v.lastColdDeliveryCard = 0;
          }
          if (!v.lastColdDeliveryCard) {
            v.lastColdDeliveryNo = "";
          }
        });
        let res;
        if (this.pageType == "add") {
          res = await saveData(params);
        }
        if (this.pageType == "edit" || this.pageType == "draftEdit") {
          res = await updateBookingData(params);
        }
        if (res.code) {
          this.goBack();
        } else {
          this.$message.warning(res.message);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.saveLoading = false;
      }
    },
    // 返回
    goBack() {
      this.$router.push({
        path: "/truckPassRegistration"
      });
    },
    //------------------下载pdf------------------
    // 下载填写文件PDFdownPdf
    downPdf() {
      this.pdfShow = true;
      this.$nextTick(() => {
        this.getPdf();
      });
    },
    getPdf() {
      this.saveLoading = true;
      var title = this.htmlTitle; //DPF标题
      html2Canvas(document.querySelector("#pdfDom"), {
        allowTaint: true,
        taintTest: false,
        useCORS: true,
        y: 72, // 对Y轴进行裁切
        // width:1200,
        // height:5000,
        dpi: window.devicePixelRatio * 4, //将分辨率提高到特定的DPI 提高四倍
        scale: 4 //按比例增加分辨率
      }).then(canvas => {
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        // 将canvas转为base64图片
        var pageData = canvas.toDataURL("image/jpeg", 1.0);

        // 设置pdf的尺寸，pdf要使用pt单位 已知 1pt/1px = 0.75   pt = (px/scale)* 0.75
        // 2为上面的scale 缩放了2倍
        var pdfX = ((contentWidth + 10) / 2) * 0.75;
        var pdfY = ((contentHeight + 500) / 2) * 0.75; // 500为底部留白

        // 设置内容图片的尺寸，img是pt单位
        var imgX = pdfX;
        var imgY = (contentHeight / 2) * 0.75; //内容图片这里不需要留白的距离

        // 初始化jspdf 第一个参数方向：默认''时为纵向，第二个参数设置pdf内容图片使用的长度单位为pt，第三个参数为PDF的大小，单位是pt
        var PDF = new JsPDF("", "pt", [pdfX, pdfY]);

        // 将内容图片添加到pdf中，因为内容宽高和pdf宽高一样，就只需要一页，位置就是 0,0
        PDF.addImage(pageData, "jpeg", 0, 0, imgX, imgY);
        PDF.save(title + ".pdf");
        this.pdfShow = false;
        this.saveLoading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.no-border-left {
  border-left: none !important;
}
.border-bottom {
  border-bottom: 1px solid #e6e6e6 !important;
}
.h80 {
  height: 80px;
}
.pl30 {
  padding-left: 30px;
}
.mt15 {
  margin-top: 10px;
}
.pd30 {
  padding-left: 30px !important;
}
// .h42 {
//   height: 42px !important;
// }
.download-tips {
  margin-left: 20px;
  font-size: 12px;
  color: #999;
  font-weight: normal;
}

.content-top {
  margin: 0 20px;
  padding: 15px 20px 0px 20px;
  width: calc(100% - 40px);
  background: #fff;
  &.no-top-info {
    height: 60px !important;
  }
  .step {
    display: flex;
    width: calc(100% - 100px);
    padding-left: 100px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e6e6e6;
    .step-item {
      display: flex;
      width: calc(50% - 100px);
      color: #c0c4cc;
      cursor: pointer;
      font-size: 16px;
      .dot {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        top: -5px;
        margin-right: 5px;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 2px solid #c0c4cc;
        color: #c0c4cc;
        background: #fff;
        color: #c0c4cc;
      }
      &.active {
        color: #303133;
        .dot {
          background: #2f4ef2;
          border: 2px solid #2f4ef2;
          color: #fff;
        }
      }
      &::after {
        display: inline-block;
        content: "";
        position: relative;
        top: 8px;
        width: calc(100% - 180px);
        height: 2px;
        background: #c0c4cc;
      }
      &.stem-item-1 {
        &::after {
          width: calc(100% - 130px);
        }
      }
      &.stem-item-2 {
        width: 200px;
        &::after {
          display: none;
        }
      }
    }
  }

  .info {
    margin-top: 15px;
    .title {
      margin: 0;
      color: #333;
      font-size: 16px;
      font-weight: bold;
    }
    .tips {
      color: #666;
      font-size: 12px;
    }
  }
}
.content-section {
  width: calc(100% - 40px);
  height: calc(100% - 54px - 156px - 10px - 45px);
  margin: 0 20px;
  padding: 20px;
  overflow: auto;
  background: #fff;
  &.no-top-info {
    height: calc(100% - 54px - 20px - 60px - 45px) !important;
  }
  .table-area {
    position: relative;
    width: 100%;
    min-width: 1200px;
    overflow: hidden;
    overflow-x: hidden;
    padding-bottom: 100px;
  }

  /deep/ .el-form {
    .el-form-item--mini {
      &.el-form-item {
        border: 1px solid #e6e6e6;
        border-bottom: none;
        margin-bottom: 0;

        &.info-title {
          .el-form-item__content {
            margin-left: 0 !important;
            padding-left: 5px !important;
            font-weight: bold;
          }
          &.bg-gray {
            div {
              background: #e6e6e6;
            }
          }
          &.fwNormal {
            .el-form-item__content {
              font-weight: normal !important;
            }
          }
        }
        &.inline-row {
          > .el-form-item__content {
            padding-left: 0 !important;
            margin-left: 0 !important;
            .el-form-item {
              border: none;
              border-left: 1px solid #e6e6e6;
            }
          }
        }
      }
      .el-form-item__label {
        padding-left: 5px;
        text-align: left;
        min-height: 40px;
        line-height: 40px;
        background: #f6f6f6;
        font-size: 15px;
        border-right: 1px solid #e6e6e6;
      }
      .el-form-item__content {
        padding-left: 10px;
        min-height: 40px;
        line-height: 40px;
        color: #606266;
        font-size: 15px;
      }
    }
    .el-form-item__error {
      top: 30% !important;
      left: auto;
      right: 10px !important;
      font-weight: normal !important;
    }
    .img-item {
      .el-form-item__error {
        right: -10px !important;
      }
    }
    .el-input__inner {
      padding-left: 0 !important;
      border: none !important;
    }
    .merge-line {
      padding-left: 5px;
      width: 161px;
      height: 100%;
      position: absolute;
      color: #606266;
      background: #f6f6f6;
      border: 1px solid #e6e6e6;
      border-bottom: none;
      font-size: 15px;
      > p {
        margin: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .el-form-item.is-required:not(.is-no-asterisk)
      > .el-form-item__label:before {
      display: none;
    }
  }

  /deep/ .el-checkbox__label {
    font-size: 15px !important;
  }
  /deep/ .el-radio__label {
    font-size: 15px !important;
  }

  .fill-time {
    position: absolute;
    bottom: 50px;
    right: 20px;
    color: #606266;
  }
  .page {
    width: 100%;
  }
  .page-2 {
    position: absolute;
    left: 100%;
  }
  .page-3 {
    position: absolute;
    left: 200%;
    .sel-select {
      padding-left: 10px;
      margin: 10px 0 15px;
      width: 250px;
      max-width: auto;
      border: 1px solid #e6e6e6;
      border-radius: 6px;
    }
  }
  .page-2,
  .page-3 {
    .el-form-item--mini {
      &.el-form-item {
        border: none;
      }
    }
  }
  .info-wrapper {
    padding: 0px 20px;
    &_title {
      margin: 10px 0;
      font-size: 16px;
      font-weight: bold;
    }
    &-sub {
      margin: 10px;
      &_title {
        margin: 10px 0;
        font-size: 14px;
        font-weight: normal;
      }
    }
  }
  .fwNormal {
    font-weight: normal;
  }
  .upload-tips-title {
    font-size: 14px;
    font-weight: normal;
    color: #606266;
  }
  .upload-img {
    display: flex;
    justify-content: space-around;
    text-align: center;
    .img-content {
      display: inline-block;
      margin-right: 20px;
      .upload-title {
        text-align: center;
        margin-top: 10px;
        color: #303133;
        font-size: 14px;
      }
      .imgCss {
        /deep/ .el-upload {
          width: auto !important;
        }
      }
      .upload-tips {
        margin: 0;
      }
    }
  }
}
.audit-operate {
  margin: 30px 0;
  .el-form-item__content {
    margin-left: 0 !important;
  }
  .audit-operate-title {
    text-align: right;
    color: #ff6600;
    margin-right: 10px;
  }
  .el-switch__core {
    position: relative;
    left: 130px;
  }
}

.btn-group {
  width: calc(100% - 40px);
  padding: 15px;
  text-align: center;
  position: absolute;
  left: 20px;
  bottom: 0px;
  background: #fff;
  box-shadow: 0 0 10px #eee;
}
// 返回顶部
.backTop {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  > i {
    width: 28px;
    height: 28px;
    display: block;
    background: url("~@/assets/images/back-top2.png") no-repeat;
  }
}
// 申请须知
.application-dialog {
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  &-content {
    padding: 0px 40px;
    position: relative;
    top: 5%;
    left: 5%;
    width: 90%;
    height: 90%;
    background: #fff;
    border-radius: 10px;
    .title {
      height: 50px;
      line-height: 50px;
      font-size: 18px;
      font-weight: bold;
      border-bottom: 1px solid #ddd;
    }
    .application-main {
      color: #666;
      height: calc(100% - 100px);
      overflow: auto;
    }
    .confirm-btn {
      text-align: center;
      height: 50px;
      line-height: 50px;
    }
  }
}
// 验证信息弹框
/deep/ .valid-dialog {
  .el-dialog__body {
    max-height: 500px;
    overflow: auto;
  }
  .valid-item {
    margin-top: 30px;
    p {
      font-size: 16px;
      font-weight: bold;
    }
    span {
      display: block;
    }
  }
}
.upload-wrapper {
  position: relative;
  .tips {
    position: absolute;
    left: 127px;
    color: #999;
    font-size: 12px;
  }
  /deep/ .upload-demo {
    width: 50%;
    margin-top: 20px;
    &.check-file {
      margin-top: -40px;
      .el-button {
        display: none;
      }
      .el-upload-list__item {
        .el-icon-upload-success {
          display: none;
        }
        &:hover {
          background: transparent;
          .el-icon-close {
            display: none !important;
            opacity: 0 !important;
          }
        }
      }
    }
  }
  .preview {
    > div {
      line-height: 30px !important;
      min-height: 30px;
    }
    position: absolute;
    top: 49px;
    left: calc(50% - 90px);
    &.check-file-preview {
      top: 50px !important;
    }
  }
}
.corp-statement {
  margin-top: 20px;
  padding: 20px;
  height: 200px;
  border: 1px solid #efefef;
  border-radius: 20px;
  .title {
    font-weight: bold;
  }
  .content {
    text-align: center;
  }
}
.e6-vr-select {
  padding-left: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
</style>
